import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { ModelUploadCommandPayload } from './interfaces/model-upload-command-payload.interface';

/**
 * Message handler for triggering a model upload in the host.
 *
 * The payload is optional:
 *  - when omitted (undefined), the host should use its default selection
 *  - when provided, it may contain items / projectId / teamId metadata.
 */
export const ModelUploadCommandMessage: MessageHandler<ModelUploadCommandPayload | undefined> = {
  send(payload?: ModelUploadCommandPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.ModelUpload, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is ModelUploadCommandPayload | undefined {
    // Allow completely missing payload
    if (payload === undefined) {
      return true;
    }

    // If present, it must be an object with optional, type-safe fields
    if (!payload || typeof payload !== 'object') {
      return false;
    }

    const p = payload as Record<string, unknown>;

    if ('items' in p && p['items'] === undefined) {
      // explicit undefined is fine; no further checks
    }

    if ('projectId' in p && typeof p['projectId'] !== 'string') {
      return false;
    }

    if ('teamId' in p && typeof p['teamId'] !== 'string') {
      return false;
    }

    if ('modelName' in p && typeof p['modelName'] !== 'string') {
      return false;
    }

    if (p['description'] != null && typeof p['description'] !== 'string') {
      return false;
    }

    return true;
  },
};
